module.exports = __webpack_public_path__ + "static/media/facebook.23f572fe.svg";